// Shared native <select> wrapper - the app's standard dropdown. Renders a real
// <select> (so mobile keeps the native picker) but with border/height/padding/
// focus styling that matches text inputs. The chevron and `appearance: none`
// come from the global `select` rule in index.css, so this component draws no
// icon of its own and there is never a double chevron.
// See docs/plans/*/FORM_CONTROL_CONSISTENCY_PLAN.md.
import { forwardRef, type SelectHTMLAttributes } from "react";
import { CONTROL_CLASS, CONTROL_CLASS_DENSE } from "../lib/controlClass.js";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  /** `dense` matches the compact inline selects (text-xs, tight padding). */
  variant?: "default" | "dense";
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { variant = "default", className, children, ...props },
  ref,
) {
  const base = variant === "dense" ? CONTROL_CLASS_DENSE : CONTROL_CLASS;
  return (
    <select {...props} ref={ref} className={`${base} ${className ?? ""}`.trim()}>
      {children}
    </select>
  );
});
